var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#ECB32C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 46.9999C17.7497 46.9999 16.9652 46.6738 16.313 46.0216C15.6608 45.3694 15.3341 44.5844 15.333 43.6666V25.3333C15.333 24.4166 15.6597 23.6321 16.313 22.9799C16.9663 22.3277 17.7508 22.001 18.6663 21.9999H25.333V18.6666C25.333 17.7499 25.6597 16.9655 26.313 16.3133C26.9663 15.661 27.7508 15.3344 28.6663 15.3333H35.333C36.2497 15.3333 37.0347 15.6599 37.688 16.3133C38.3413 16.9666 38.6675 17.751 38.6663 18.6666V21.9999H45.333C46.2497 21.9999 47.0347 22.3266 47.688 22.9799C48.3413 23.6333 48.6674 24.4177 48.6663 25.3333V43.6666C48.6663 44.5833 48.3402 45.3683 47.688 46.0216C47.0358 46.6749 46.2508 47.001 45.333 46.9999H18.6663ZM28.6663 21.9999H35.333V18.6666H28.6663V21.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerSupport);
export default __webpack_public_path__ + "static/media/career-support.e28b0e0951368f897fd4b62957ab5bfe.svg";
export { ForwardRef as ReactComponent };